import { ButtonProps } from '@mui/material';
import { JSX } from 'react';
import { LoadingButton } from '@mui/lab';
import { QuoteItem } from '../common/types/quotes';
import { useRequestQuote } from '../common/components/mutations';
import { useSnackbar } from 'notistack';

interface RequestQuoteButtonProps extends ButtonProps {
  quote: QuoteItem;
}

/**
 * Button to request a quote
 */
const RequestQuoteButton = ({ quote, ...buttonProps }: RequestQuoteButtonProps): JSX.Element => {
  const { enqueueSnackbar } = useSnackbar();
  const { isPending: isLoading, mutateAsync } = useRequestQuote();

  const handleClickQuote = async (): Promise<void> => {
    try {
      const result = await mutateAsync(quote.id);
      enqueueSnackbar({
        message: result.detail || result.title || 'Quote has been generated for this need',
        variant: 'success',
      });
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      const message =
        error.response?.data?.myriadErrors
          ?.map(({ description }: { description: string }) => description)
          .join('\n') ||
        error.response?.data?.errorMessage ||
        error.response?.data?.title ||
        error.message;
      enqueueSnackbar({ message, variant: 'error' });
    }
  };

  return <LoadingButton {...buttonProps} loading={isLoading} onClick={handleClickQuote} />;
};

export default RequestQuoteButton;
